import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';

import { StoreService } from '../../../core';

@Component({
  selector: 'app-simple-it',
  templateUrl: './simple-it.component.html',
  styleUrls: ['./simple-it.component.scss']
})
export class SimpleItComponent implements OnInit, AfterViewInit {

  category;

  constructor(
    private router: Router,
    private location: Location,
    private storeService: StoreService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.category = this.route.snapshot.paramMap.get('category');
  }

  previousPage() {
    this.storeService.setPreviousRoute(true);
    this.location.back();
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}
